import React, { useEffect, useState } from "react"
import { motion } from "framer-motion"
import { springVariants, rightVariants, opacityVariants, leftVariants, springViewport } from '../utils/framerVariants'

const AccordeonHighlight = ({ data }) => {

  const [open, setOpen] = useState(false);
  const hasSpacing = data.Margins.startsWith("None");

  useEffect(() => {
    const toggleContent = document.querySelector(`.c${data.id}`);
    const toggle = document.querySelector(`.a${data.id}`);

    const change = () => {
      toggleContent.classList.toggle("open");
      toggle.classList.toggle("open");
      setOpen(!open);
    };

    toggle.addEventListener("click", change);

    return () => {
      toggle.removeEventListener("click", change);
    };
  }, [data.id, open]);

  return (
    <div className={`a${data.id} accordeon-wrap container mx-auto max-w-6xl lg:max-w-7xl 2xl:max-w-8xl px-4 sm:px-24 md:px-48 lg:px-64 ${hasSpacing ? "mb-4" : "mb-16 md:mb-24 lg:mb-32 xl:mb-48"}`}>
      <motion.div
        variants={opacityVariants}
        initial="invisible"
        whileInView="visible"
        viewport={springViewport}
        className="accordeon-panel p-8 md:p-12"
      >
        <div className="header">
          {data.Subheadline && <p className="accordeon-title mb-4">{data.Subheadline}</p>}
          {data.Headline && <h2 className="accordeon-title text-headline tracking-headline leading-headline font-bold max-w-xs pr-12 lg:max-w-md xl:max-w-xl 2xl:max-w-2xl">{data.Headline}</h2>}
        </div>
        <div className={`c${data.id} hidden-contents accordeon-title`}>
          <div className="mt-8 max-w-2xl" dangerouslySetInnerHTML={{ __html: data.Text }} />
        </div>
        <div className="absolute top-2 md:top-3 right-4 md:right-5 accordeon-icons text-[32px] md:text-[36px] tracking-headline-lg leading-none font-medium"></div>
      </motion.div>
    </div>
  )
}

export default AccordeonHighlight;
